import {
  CARD_PAYMENT_MAX_AMOUNT_IN_POUNDS,
  CARD_PAYMENT_MIN_AMOUNT_IN_POUNDS,
} from "@/constants/finance"
import { formatMoney } from "@/helpers/moneyHelpers"

export default (value: string | null) => {
  if (value === null || value === "") return true

  if (Number(value) < CARD_PAYMENT_MIN_AMOUNT_IN_POUNDS) {
    return `Minimum amount is ${formatMoney({
      amount: CARD_PAYMENT_MIN_AMOUNT_IN_POUNDS,
    })}`
  }

  if (Number(value) > CARD_PAYMENT_MAX_AMOUNT_IN_POUNDS) {
    return `Maximum amount is ${formatMoney({
      amount: CARD_PAYMENT_MAX_AMOUNT_IN_POUNDS,
    })}`
  }

  return true
}
